import { render, staticRenderFns } from "./PopupsV2.vue?vue&type=template&id=24ee924a"
import script from "./PopupsV2.vue?vue&type=script&lang=js"
export * from "./PopupsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports